import { useMemo } from 'react';

import type { IFuseOptions } from 'fuse.js';

import type { CatalogItem } from '@/entities/catalog-item';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';

import { toFuseOptions } from './settingsSchema';
import { useFuzzySearchSettings } from './useFuzzySearchSettings';

/**
 * Returns the live Fuse options when the QA tuning flag is on, or `undefined`
 * (use built-in defaults) otherwise. The result is memoised so the search hook
 * only rebuilds its Fuse index when the tuning actually changes.
 */
export function useTunedFuzzyOptions(): IFuseOptions<CatalogItem> | undefined {
  const enabled = useFlag(FeatureFlag.CatalogFuzzySearchSettings);
  const { settings } = useFuzzySearchSettings();

  return useMemo(() => (enabled ? toFuseOptions(settings) : undefined), [enabled, settings]);
}
